import { createFileRoute } from '@tanstack/react-router';
import { HomeGate } from '@/features/account/shell/HomeGate';
import EditProfilePicturePreviewPage from '@/features/account/profile/edit-profile-picture-preview';
import { ensureOnboardingProgressLoaded } from '@/features/account/onboarding/shared/ensure-onboarding-progress.loader';

export const Route = createFileRoute('/perfil/foto/preview')({
  component: () => (
    <HomeGate>
      <EditProfilePicturePreviewPage />
    </HomeGate>
  ),
  loader: ({ context }) => ensureOnboardingProgressLoaded(context),
});
